import { EntitiesMap, EntityHash, EntityKey, EntityMap, EntityType } from "../../entities";

export default function mergeEntities<T extends EntitiesMap>(
  aEntities: T,
  bEntities: {
    [key in EntityKey & keyof T]?: {
      [k: string]: Partial<EntityHash[key]> | undefined;
    }
  }
): T {
  const res: T = { ...(aEntities as any) };
  Object.entries(bEntities).forEach(([_key, entities]) => {
    const key = _key as EntityKey;
    res[key] = mergeEntityHash(res[key]!, entities!);
  });
  return res;
}

export function mergeEntityHash<T extends EntityType>(aMap: EntityMap<T>, bMap: EntityMap<T>): EntityMap<T> {
  const res = { ...aMap };
  Object.entries(bMap).forEach(([id, entity]) => {
    if (res[id]) {
      res[id] = mergeEntity(res[id]!, entity!);
    } else {
      res[id] = entity;
    }
  });
  return res;
}

export function mergeEntity<T extends EntityType>(aEntity: T, bEntity: Partial<T>): T {
  const res = { ...(aEntity as any) };
  Object.entries(bEntity).forEach(([key, val]) => {
    if (typeof res[key] === undefined) {
      res[key] = val;
    } else {
      if (typeof val !== undefined) {
        res[key] = val;
      }
    }
  });
  return res;
}



// WEBPACK FOOTER //
// ./frontend/src/lib/entities/mergeEntities.ts